var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6933 21.222C2.63556 21.222 1.74359 20.4644 1.5692 19.4224L0.0297607 10.1857C-0.0745843 9.55962 0.0983621 8.92496 0.502878 8.44611C0.917399 7.95726 1.52207 7.67567 2.15957 7.67567C2.62984 7.67567 3.08007 7.83007 3.46171 8.1231L6.04606 10.0985L11.269 3.04732C11.6793 2.49415 12.3096 2.17542 13 2.17542C13.689 2.17542 14.3207 2.49416 14.731 3.04876L19.9539 10.0985L22.5383 8.1231C22.9199 7.83007 23.3702 7.67567 23.8405 7.67567C24.478 7.67567 25.0812 7.95727 25.4971 8.44755C25.9016 8.92497 26.0746 9.55962 25.9702 10.1857L24.4308 19.4224C24.2564 20.4658 23.3631 21.222 22.3067 21.222H3.6933Z",
    fill: "url(#paint0_linear_1058_11445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6933 20.0026C2.63556 20.0026 1.74359 19.245 1.5692 18.203L0.0297607 8.96633C-0.0745843 8.34026 0.0983621 7.7056 0.502878 7.22675C0.917399 6.7379 1.52207 6.45631 2.15957 6.45631C2.62984 6.45631 3.08007 6.61071 3.46171 6.90374L6.04606 8.87913L11.269 1.82796C11.6793 1.27479 12.3096 0.956055 13 0.956055C13.689 0.956055 14.3207 1.2748 14.731 1.8294L19.9539 8.87913L22.5383 6.90374C22.9199 6.61071 23.3702 6.45631 23.8405 6.45631C24.478 6.45631 25.0812 6.73791 25.4971 7.22819C25.9016 7.70561 26.0746 8.34026 25.9702 8.96633L24.4308 18.203C24.2564 19.2465 23.3631 20.0026 22.3067 20.0026H3.6933Z",
    fill: "url(#paint1_linear_1058_11445)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7596 10.2457L13.9506 2.40407C13.4775 1.76513 12.5212 1.76513 12.0466 2.40407L6.23764 10.2457L2.87142 7.67134C2.01808 7.01954 0.807379 7.74711 0.984623 8.80628L2.52406 18.043C2.61983 18.6147 3.11299 19.0321 3.69189 19.0321H12.9972H22.3025C22.8814 19.0321 23.3759 18.6133 23.4703 18.043L25.0097 8.80628C25.187 7.74711 23.9748 7.01812 23.1229 7.67134L19.7596 10.2457Z",
    fill: "url(#paint2_linear_1058_11445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1058_11445",
    x1: 8.97442,
    y1: 23.9987,
    x2: 16.9728,
    y2: 0.527908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6B49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1058_11445",
    x1: 8.97442,
    y1: 22.7793,
    x2: 16.9728,
    y2: -0.69146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1058_11445",
    x1: 9.31051,
    y1: 21.7905,
    x2: 16.5789,
    y2: 0.462244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6B49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB749"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankCrown);
export default __webpack_public_path__ + "static/media/rank-crown.2ca5f6e7a50af7166dbeedb5923bfceb.svg";
export { ForwardRef as ReactComponent };